export default __webpack_public_path__ + "static/media/map.c325a68d.png";